import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint implicit-arrow-linebreak: 0 */
import React, { Component } from 'react';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var DEFAULT_OPTIONS = {
  shouldForwardAction: false
};
var withActions = function withActions() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var actionHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;
  return function wrapComponent(WrappedComponent) {
    var WithActions = /*#__PURE__*/function (_Component) {
      _inherits(WithActions, _Component);
      var _super = _createSuper(WithActions);
      function WithActions() {
        var _this;
        _classCallCheck(this, WithActions);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", initialState);
        _defineProperty(_assertThisInitialized(_this), "getState", function () {
          return _objectSpread(_objectSpread({}, _this.props), _this.state);
        });
        _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
          var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
          var handler = actionHandlers[action.type];
          var _this$props = _this.props,
            onAction = _this$props.onAction,
            shouldForwardAction = _this$props.shouldForwardAction;
          var result;
          if (handler) {
            result = handler({
              params: action.payload,
              getState: _this.getState,
              setState: _this.setState.bind(_assertThisInitialized(_this))
            });
          }
          if (options.shouldForwardAction || shouldForwardAction) {
            result = onAction(action, result);
          }
          return result;
        });
        return _this;
      }
      _createClass(WithActions, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, this.state, {
            onAction: this.handleAction
          }));
        }
      }]);
      return WithActions;
    }(Component);
    return WithActions;
  };
};
export default withActions;